module.exports = __webpack_public_path__ + "img/ico12.f4de986e.svg";